import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { BlockTitle } from '~/components/atoms/block-title';
import Accordion from '~/components/ui/Accordion/Accordion';
import { Text } from '~/components/ui/text';
import { PATH } from '~/constants/route-path';
import { StyledContainer, StyledViewAll } from '~/pages/HomePage/components/FAQ/styled';
import { getIsDesktop } from '~/store/reducers/app/selectors';

const LIST = [
  {
    title: 'common:faq.qrGeneration.title',
    description: 'common:faq.qrGeneration.description',
  },
  {
    title: 'common:faq.createAccount.title',
    description: 'common:faq.createAccount.description',
  },
  {
    title: 'common:faq.freeAvailable.title',
    description: 'common:faq.freeAvailable.description',
  },
];

export default function FAQ() {
  const { t } = useTranslation();

  const isDesktop = useSelector(getIsDesktop);

  return (
    <StyledContainer>
      <BlockTitle text={t('common:faq.title')} hideRight />
      <Text variant={isDesktop ? 'h1.5' : 'h2'} sx={{ marginBottom: '51px', marginTop: '16px' }}>
        {t('landing:faqBlock.title')}
      </Text>
      {LIST.map(({ title, description }) => {
        return <Accordion key={title} summary={t(title)} details={t(description)} />;
      })}
      <StyledViewAll to={PATH.UNAUTH.FAQ}>{t('landing:faqBlock.link')}</StyledViewAll>
    </StyledContainer>
  );
}
